export default __webpack_public_path__ + "static/media/u2-loader.2179c39f.gif";